import { Image } from '@chakra-ui/react';
import logo from './logo-full.svg';

const Logo = (props) => <Image src={logo} {...props} />;

export default Logo;
